import React from "react";
import "./styles.css";
import wallet from "./utils/wallet";

export default function App() {
  return (
    <div className="App">
      <h1>Hello CodeSandbox</h1>
      <button onClick={() => wallet.StartWallet()}>Start</button>
      <h2>Start editing to see some magic happen!</h2>
    </div>
  );
}
